<template>
   <div id="inside" style="">
     
    <div class="container">
      <div class="row">
        <div class="">
        </div>
        <div class="btn-group btn-group-sm">
            <a
              href="/"
              class="btn btn-link d-flex flex-column justify-content-center text-secondary"
              ><i class="fa fa-home fa-fw fa-lg"></i
            ></a>
            <router-link
              to="/dashboard/negociar"
              ><a class="btn btn-link text-secondary">Negociar</a>
            </router-link>
            <router-link
              to="#"
              ><a href="#" class="btn btn-link text-secondary" style="text-decoration: none; cursor: initial;">Vencimento</a>
            </router-link>
        </div>
        <div class="col-md-12">
            <h1>Vencimento</h1>
        </div>
        
      </div>
    </div>
    <div class="container">
      <div class="row">

        <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-3">
        </div>
          <!-- v-for="(value, key, index) in contract"
          :key="`${key}-${index}`"> -->
          <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-6">

          <div class="card">
            <div class="card-body border-top-0">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <div class="form-group text-muted">
                    <p class="mt-3">Selecione o dia de vencimento</p>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="dia1" name="dia" class="custom-control-input">
                      <label for="dia1" class="custom-control-label">
                        dia 5
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="dia2" name="dia" class="custom-control-input">
                      <label for="dia2" class="custom-control-label">
                        dia 15
                      </label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="dia3" name="dia" class="custom-control-input">
                      <label for="dia3" class="custom-control-label">
                        dia 25
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 d-flex justify-content-center mt-3">
                  <a @click="propostas()" class="btn btn-secondary mr-1 mb-1 mx-auto py-2 px-4">
                    Prosseguir
                  </a>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="d-inline-flex flex-wrap flex-column col-acao col-lg-3">
          </div>
      </div>
      <div class="row border-top border-info mx-2 pt-3">
        <div class="col-lg-6">
          <a href="" class="btn-link small">Voltar para negociar</a>
        </div>
        <div class="col-md-6">
          <p class="mt-3 small text-info">
            Após escolher vencimento você será levado à tela de boletos.
          </p>
          
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatCurrencieValueBRL as formatValue, formatData } from "@/utils/helpers";

export default {
    name: "HistoricoPagamentos",
     components: {
    },
    data () {
        return {
            loadDeal: false,
            negociacao: null,
            contract :null,
            selectDeal:null,
            digitalLine:null,
            contractFull: null,
            checkSelectAll: false,
            checkContract: false,
            links: [],
        }
    },
    methods: {
        formatValue,
        formatData,

        ...mapActions('minhasDividas', ['ActionDividaNegociar']),

        deactivated() {
            this.divida = null;
            this.negociacao = null;
            this.selectDeal = null;
            this.digitalLine = null;
        },
        voltar() {
             this.$router.push({ 
               name: 'negociarDivida',
               params: { contracts: this.contractFull },
              });
        },
        showDigitalLine(){
          this.digitalLine = this.selectDeal.linhaDigitavel;
        },

        selectAll() {
              var marcar = document.getElementById('all').checked;
              var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
              for (var i = 0; i < lista.length; i++) {
                lista[i].checked = marcar;
              }
        },

        select() {
          var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
          var all = document.getElementById('all');
          if(lista.length <= 2) {
            all.checked = false;
          }
        },

        clear() {
              var lista = document.getElementsByClassName("form-check-input check1 bg-primary");
              for (var i = 0; i < lista.length; i++) {
                lista[i].checked = false;
              }
        },

        propostas() {
             this.$router.push({ 
               name: 'propostas',
               params: { contracts: this.contractFull },
              });
        },
    },
    async created() {
        this.user.Menus.forEach((menuId) => {
          switch (parseInt(menuId)) {
            case 2:
              this.links.push({
                icon: "",
                text: "Contratos Negociáveis",
                route: "/dashboard/minhas-dividas",
              });
              break;
            case 1:
              this.links.push({
                icon: "",
                text: "Boletos Ativos",
                route: "meusBoletos",
              });
              break;
            case 3:
              this.links.push({
                icon: "",
                text: "Acordos",
                route: "/dashboard/meus-acordos",
              });
              break;
          }
        });
        this.loadDeal = true;
        this.contractFull = this.$route.params.contracts;
        this.contract = this.contractFull[0].environments[0].contracts
        this.loadDeal = false;
    },
    computed: {
      ...mapState("auth", ["user"]),
      isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    }
};
</script>
